var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._t("default",null,{"attrs":{
      errorMessages: _vm.getServerErrors || _vm.activeErrorMessages,
      label: this.$t(`label.${_vm.name}`),
    },"hasErrors":_vm.hasErrors,"listeners":{ blur: () => _vm.preferredValidator.$touch() }})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }